import { Editor } from 'slate';
import { isListItem } from '../utilities.mjs';

function findListItems(editor, {
  at = editor.selection
}) {
  if (!at) {
    return [];
  }
  return Array.from(Editor.nodes(editor, {
    at,
    match: isListItem
  }));
}

export { findListItems };
